"use client";
import { Box, Accordion } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Text, List } from "@nxt-costco-com/forge-components";
import { SpaceXs, SpaceMd, ColorBlue500, ColorBlue100, ColorWhite, ColorGreen500, SpaceSm, SpaceLg, ColorTextDefault, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { ChevronDown } from "@nxt-costco-com/forge-icons/icons/ChevronDown";
const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isPreferredWarehouse"
})(({ isPreferredWarehouse }) => ({
  backgroundColor: isPreferredWarehouse ? ColorBlue100 : ColorWhite,
  border: isPreferredWarehouse ? `solid ${ColorBlue500}` : "none",
  borderWidth: isPreferredWarehouse ? `2px 2px 2px 4px` : "",
  boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
  display: "flex",
  flexDirection: "column",
  padding: SpaceMd,
  rowGap: SpaceXs
}));
const MyWarehouse = styled(Box)`
    display: flex;
    align-items: center;
    color: ${ColorGreen500};
`;
const NameAndDistanceAndLocation = styled(Box)`
    display: flex;
    align-items: flex-start;
    gap: ${SpaceSm};
`;
const LocationIconWrapper = styled(Box)`
    display: flex;
    margin-top: 2px;
    height: 20px;
    width: 20px;
`;
const NameAndDistance = styled("span")`
    align-items: flex-end;
`;
const Distance = styled(Text)`
    margin-left: ${SpaceXs};
    white-space: nowrap;
`;
const SeeWarehouseDetails = styled(Accordion, {
  shouldForwardProp: (prop) => prop !== "isPreferredWarehouse"
})(({ isPreferredWarehouse }) => ({
  "&::before": {
    display: "none"
  },
  backgroundColor: isPreferredWarehouse ? ColorBlue100 : ColorWhite,
  border: "none",
  boxShadow: "none",
  marginLeft: SpaceLg
}));
const AccordianSummarySx = {
  "& .MuiAccordionSummary-content": {
    margin: 0,
    flex: "0 1 auto"
  },
  "&.MuiButtonBase-root.MuiAccordionSummary-root": {
    justifyContent: "flex-start"
  },
  "&.MuiButtonBase-root.MuiAccordionSummary-root.Mui-focusVisible": {
    backgroundColor: "transparent",
    outline: "2px auto -webkit-focus-ring-color",
    outlineoffset: "2px"
  },
  textAlign: "left",
  alignItems: "flex-start",
  display: "flex",
  gap: SpaceXs,
  minHeight: "24px"
};
const StyledChevronDown = styled(ChevronDown)`
    color: ${ColorTextDefault};
    height: 20px;
    width: 20px;
`;
const Subheader = styled(Text)`
    line-height: 20px;
    margin: ${SpaceMd} 0 0 0;
`;
const Icons = styled(List)`
    display: flex;
    column-gap: ${SpaceXs};
    padding-top: ${SpaceXxs};
    margin: 0;
    padding-inline-start: 0;
`;
const GasList = styled("dl")`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin: 0;
    column-gap: 20px;
    justify-self: start;
`;
const listItemStyles = {
  display: "flex",
  height: "20px",
  width: "20px"
};
const iconStyles = {
  height: "20px",
  width: "20px"
};
export {
  AccordianSummarySx,
  Distance,
  GasList,
  Icons,
  LocationIconWrapper,
  MyWarehouse,
  NameAndDistance,
  NameAndDistanceAndLocation,
  SeeWarehouseDetails,
  StyledChevronDown,
  Subheader,
  Wrapper,
  iconStyles,
  listItemStyles
};
